/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type MembershipFeePageContentModelContentType = typeof MembershipFeePageContentModelContentType[keyof typeof MembershipFeePageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MembershipFeePageContentModelContentType = {
  membershipFeePage: 'membershipFeePage',
} as const;
